import { Box, Typography, Link, useTheme } from "@mui/material";
import { FC } from "react";
import Image from "next/image";

export const Footer: FC = (props) => {
  const theme = useTheme();
  return (
    <Box
      component="footer"
      sx={{
        paddingLeft: "300px",
        backgroundColor: theme.palette.background.default, // Couleur non transparente
        py: 1.5,
        borderTop: "1px solid #e0e0e0",
        fontSize: "1rem",
        fontWeight: 500,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        {/* Left Logos */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 5 }}>
          <Link
            href="https://www.inserm.fr/"
            target="_blank"
            sx={{ display: "flex", alignItems: "center" }}
          >
            <Image
              src="/assets/logo/logo_inserm.png"
              alt="INSERM Logo"
              width={96}
              height={40}
              style={{ cursor: "pointer" }}
            />
          </Link>
          <Link
            href="https://www.msdavenir.fr/"
            target="_blank"
            sx={{ display: "flex", alignItems: "center" }}
          >
            <Image
              src="/assets/logo/logo_msdavenir.png"
              alt="MSDAvenir Logo"
              width={86}
              height={38}
              style={{ cursor: "pointer" }}
            />
          </Link>
          <Link
            href="https://anrs.fr/fr/"
            target="_blank"
            sx={{ display: "flex", alignItems: "center" }}
          >
            <Image
              src="/assets/logo/logo_anrs.png"
              alt="ANRS Logo"
              width={86}
              height={38}
              style={{ cursor: "pointer" }}
            />
          </Link>
        </Box>

        <Box
          sx={theme => ({
            display: "flex",
            alignItems: "center",
            gap: 5,
            "& a": {
              color: theme.palette.secondary.contrastText,
              textDecorationColor: theme.palette.secondary.contrastText,
            }
          })}
        >
          <Typography variant="body2">
            <a
              href="https://lsdengue-arbogen.com/arbogen/#team"
              target="_blank"
              rel="noopener noreferrer"
            >
              About us
            </a>
          </Typography>
          <Link
            href="/docs/Governance Data/gdpr"
            variant="body2"
            target="_blank"
            rel="noopener noreferrer"
          >
            GDPR
          </Link>
          <Link
            href="/docs/Governance Data/Licenses_And_Rights"
            variant="body2"
            target="_blank"
            rel="noopener noreferrer"
          >
            Governance
          </Link>
          <Link
            href="/contact"
            variant="body2"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact us
          </Link>
        </Box>

        {/* Right: Copyright & Natural Solutions */}
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 5 }}
          paddingRight="30px"
        >
          <Typography
            variant="body2"
            sx={{ color: "#444", mr: 1, fontWeight: 400 }}
          >
            Arbogen © 2025
          </Typography>
          <Link
            href="https://www.natural-solutions.eu/"
            target="_blank"
            sx={{ display: "flex", alignItems: "center" }}
          >
            <Image
              src="/assets/logo/logo_ns.png"
              alt="natural solutions logo"
              width={125}
              height={50}
              style={{ cursor: "pointer" }}
            />
          </Link>
        </Box>
      </Box>
    </Box>
  );
};
